exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-viewer__wrapper {\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, .5);\n  z-index: 10000000000;\n}\n\n.video-viewer__loading {\n  color: #fff;\n  text-align: center;\n  line-height: 100%;\n}\n\n.video-viewer__video {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  height: 100%;\n}\n\n.video-viewer__close {\n  position: absolute;\n  top: 50px;\n  right: 50px;\n  z-index: 1;\n}\n\n.video-viewer__close i {\n  font-size: 40px;\n}", ""]);

// exports
